reIsBinary